import { useState } from 'react';
import { API_URL } from '../api/client.js';
import { useOverview, useRebuildProjections } from '../api/queries.js';
import { Button, Card, Mono, Page, Problem } from '../components/ui.jsx';
import { formatNumber } from '../utils/format.js';

/**
 * Where the console stands, and the one maintenance action worth exposing: rebuilding the read
 * models. It is safe by construction — it replays facts and takes no decision of its own — but it
 * holds the store while it runs, so it stays a deliberate click and never something automatic.
 */
export function Settings() {
  const overview = useOverview();
  const rebuild = useRebuildProjections();
  const [result, setResult] = useState<string | undefined>();

  return (
    <Page eyebrow="SISTEMA" title="Settings" description="Configurazione della console e manutenzione delle viste.">
      <Card title="Connessione">
        <dl className="details">
          <dt>API</dt>
          <dd>
            <Mono value={API_URL} />
          </dd>
          <dt>Console</dt>
          <dd>
            <Mono value={window.location.origin} />
          </dd>
          <dt>Autenticazione</dt>
          <dd>Security SSO (OpenID Connect, Authorization Code + PKCE)</dd>
          <dt>Posizione del registro</dt>
          <dd>{formatNumber(overview.data?.sequence ?? 0)} fatti</dd>
        </dl>
      </Card>

      <Card title="Ricostruzione delle viste" hint="Il registro non viene toccato">
        <p className="muted">
          Svuota ogni proiezione e la ricostruisce rileggendo il registro dall&apos;inizio. Serve dopo un cambio di forma di
          una vista, e come verifica: se dopo una ricostruzione la console mostra qualcosa di diverso, il difetto è in una
          proiezione — mai nella storia, che non è riscrivibile.
        </p>
        {rebuild.error ? <Problem error={rebuild.error} /> : null}
        {result ? <p className="ok">{result}</p> : null}
        <Button
          variant="danger"
          disabled={rebuild.isPending}
          onClick={() => {
            void rebuild.mutateAsync().then((answer) => setResult(`Ricostruite le viste da ${formatNumber(answer.applied)} fatti.`));
          }}
        >
          {rebuild.isPending ? 'Ricostruisco…' : 'Ricostruisci le viste'}
        </Button>
      </Card>
    </Page>
  );
}
